import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Breadcrumb, Row, Button, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Loading } from '@rd-web-markets/shared/dist/util';
import { SHOW_CLAIM_GROUP_TASKS, SHOW_CLAIM_GROUPS_SELECTOR, SHOW_ADD_FINANCIAL_YEAR } from '@rd-web-markets/market/dist/constants';
import BreadcrumbsPortal from '@rd-web-markets/shared/dist/util/BreadcrumbsPortal';
import NoClaimsPage from '@rd-web-markets/shared/dist/claim_group/NoClaimsPage';
import ClaimGroupSidebar from '@rd-web-markets/shared/dist/pages/setup/ClaimGroupSidebar';
import { ClaimState } from '@rd-web-markets/market/dist/claim';
import { claimGroupMenuItemsCreator } from '@rd-web-markets/market/dist/company/claimGroupMenuItemsCreator';
import ElsterSubmission from '@rd-web-markets/market/dist/company/ElsterSubmission';
const MarketClaimGroupMasterPage = _ref => {
  var _claimGroup$tasks;
  let {
    company,
    claimGroup,
    allClaimGroups,
    accountType,
    companyId,
    claimGroupId,
    loading,
    setLoading,
    markTaskComplete,
    updateClaimGroupTask,
    resetCompany,
    ClaimGroupNavigation
  } = _ref;
  const {
    t
  } = useTranslation();
  if (!company || !allClaimGroups.length) return /*#__PURE__*/React.createElement(Loading, null);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ClaimGroupSidebar, {
    claimGroup: claimGroup,
    company: company,
    claims: company.claims,
    accountType: accountType,
    highlightedMenuItem: "de/element_overview",
    customMenuItems: claimGroupMenuItemsCreator({
      company,
      allClaimGroups
    })
  }), /*#__PURE__*/React.createElement("div", {
    className: "ps-4 pe-4"
  }, /*#__PURE__*/React.createElement(BreadcrumbsPortal, null, /*#__PURE__*/React.createElement(Breadcrumb, null, /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: "/".concat(accountType)
    }
  }, t('home')), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    linkAs: Link,
    linkProps: {
      to: "/".concat(accountType, "/companies/")
    }
  }, t('companies')), /*#__PURE__*/React.createElement(Breadcrumb.Item, {
    active: true
  }, company.name))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex",
    style: {
      height: '60px'
    }
  }, /*#__PURE__*/React.createElement("h1", {
    className: "text-primary mb-0"
  }, company.name), /*#__PURE__*/React.createElement(Button, {
    className: "ms-4 h-75",
    size: "lg",
    variant: "primary",
    as: Link,
    to: "/".concat(accountType, "/companies/").concat(company.id, "/edit")
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons"
  }, "edit")), company.risk == 'high' && /*#__PURE__*/React.createElement("div", {
    className: "ms-2"
  }, /*#__PURE__*/React.createElement(OverlayTrigger, {
    placement: "right",
    overlay: /*#__PURE__*/React.createElement(Tooltip, null, t('company_sic_code_is_high_risk'))
  }, /*#__PURE__*/React.createElement("span", {
    className: "material-icons",
    style: {
      color: '#DCA90E'
    }
  }, "warning")))), /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3"
  }, SHOW_ADD_FINANCIAL_YEAR && /*#__PURE__*/React.createElement(ElsterSubmission, {
    companyId: companyId,
    setLoading: setLoading,
    loading: loading,
    afterSubmitActions: resetCompany
  }))), !claimGroup && /*#__PURE__*/React.createElement(NoClaimsPage, {
    company: company,
    accountType: accountType
  }), !!claimGroup && /*#__PURE__*/React.createElement(React.Fragment, null, !SHOW_CLAIM_GROUPS_SELECTOR && ClaimGroupNavigation && /*#__PURE__*/React.createElement(ClaimGroupNavigation, {
    claimGroups: allClaimGroups,
    claim_group_id: claimGroupId,
    accountType: accountType,
    company: company,
    claimGroupId: claimGroup.id
  }), /*#__PURE__*/React.createElement(Row, {
    className: "justify-content-end mb-1 mt-3"
  }), !!((_claimGroup$tasks = claimGroup.tasks) !== null && _claimGroup$tasks !== void 0 && _claimGroup$tasks.length) && SHOW_CLAIM_GROUP_TASKS && /*#__PURE__*/React.createElement(ClaimState, {
    tasks: claimGroup.tasks,
    markTaskComplete: markTaskComplete,
    updateClaimGroupTask: updateClaimGroupTask,
    claimGroup: claimGroup
  }))));
};
export default MarketClaimGroupMasterPage;